module.exports = __webpack_public_path__ + "img/icon-loader-lets3.d8a06c10.svg";